<app-navbar-style-admin></app-navbar-style-admin>
<div class="inner-banner inner-bg4">
    <div class="container">
        <div class="banner-list">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-7">
                    <ul class="list">
                        <li><a href="/adminPanel">Dashboard</a></li>
                        <li><i class='bx bx-chevron-right'></i></li>
                        <li class="active">Response</li>
                    </ul>
                </div>
                <div class="col-lg-6 col-md-5 text-end">
                    <button class="default-btn" (click)="exportToExcel()">Export XL</button>
                </div>
                
            </div>
        </div>
    </div>
</div>

<div class="blog-details-area pt-50 pb-70">
    <div class="container">
        <div class="row">
            <!-- Cards for User Names -->
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-3 col-md-4 mb-4" *ngFor="let user of uniqueUsers">
                        <div class="card user-card" (click)="selectUser(user)" style="cursor: pointer; box-shadow: 0 4px 8px rgba(0,0,0,0.1); border-radius: 10px;">
                            <div class="card-body text-center">
                                <h5 class="card-title default-btn" style="border-radius: 10px; padding: 10px 20px; background-color: #4caf50; color: white;">
                                    {{ user.UserName }}
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Display Questionnaire Types -->
            <div *ngIf="selectedUser" class="col-lg-12">
                <h4>Select Questionnaire Type for {{ selectedUser.UserName }}</h4>
                <div class="row">
                    <div class="col-lg-3 col-md-4 mb-4" *ngFor="let questionnaire of questionnaireOptions">
                        <div class="card questionnaire-card" (click)="filterByQuestionnaire(questionnaire.QuestionnaireId)" style="cursor: pointer; box-shadow: 0 4px 8px rgba(0,0,0,0.1); border-radius: 10px;">
                            <div class="card-body text-center">
                                <h5 class="card-title default-btn" style="border-radius: 10px; padding: 10px 20px; background-color: #2196f3; color: white;">
                                    {{ questionnaire.QuestionnaireName }}
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Display Responses -->
         <!-- Display Responses -->
<!-- Display Responses -->
<header class="card-header headerbar" style="border-radius:100px;">
    <h4 class="card-title mt-2 text-center" style="color:white">Response For {{QuestionnaireName}}</h4>
</header>
<div *ngIf="filteredRowData.length > 0; else noResponses" class="col-lg-12">
    <div class="row">
        <div class="col-12 mb-4" *ngFor="let response of filteredRowData">
            <div class="card response-card" style="box-shadow: 0 4px 8px rgba(0,0,0,0.1); border-radius: 10px;">
                <div class="card-body">
                    <!-- <h5 class="card-title" style="color: #4caf50;"><strong>Question:</strong></h5> -->
                    <p style="color: black;"><strong style="color: #4caf50;">Question:</strong> {{ response.QuestionHeadline }}</p>
                    <!-- <h5 class="card-title" style="color: #2196f3;"><strong>Response:</strong></h5> -->
                    <p style="color: black;"> <strong style="color: #2196f3;">Response:</strong>{{ response.ResponseValue }}</p>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #noResponses>
    <p>No responses available for the selected questionnaire.</p>
</ng-template>


        </div>
    </div>
</div>

<style>
    .default-btn {
        background-color: #28a745;
        color: white;
        border: none;
        padding: 10px 20px;
        border-radius: 5px;
        transition: all 0.3s ease-in-out;
    }

    .default-btn:hover {
        background-color: #218838;
        color: white;
    }

    .card {
        transition: transform 0.3s ease-in-out;
    }

    .card:hover {
        transform: translateY(-10px);
    }

    .headerbar {
        background-color: #343a40;
        color: white;
    }

    .headerbar h4 {
        margin: 0;
    }

    .card-title {
        margin: 0;
    }

    .list a {
        color: #333;
        text-decoration: none;
    }

    .list a:hover {
        text-decoration: underline;
    }
</style>
